import React from 'react';
import { useNavigate } from 'react-router-dom';
import routes_web from '../../connections/routes_web';

// Imports QApp
import NavbarTop from './moduleComponents/NavbarTop';
import TabPrincipal from './tab_principal/principal_main';

const AccountsMain = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
      <div className="max-w-5xl w-full mx-auto pt-14">
        <NavbarTop
          title="Ecosystem"
          onHomeClick={() => navigate(routes_web.accounts_home)}
        />

        <div>
          <TabPrincipal />
        </div>
      </div>
    </div>
  );
};

export default AccountsMain;
